export default function guest({next, store}) {
  if (store.getters['auth/isUserLoggedIn']) {
    return next({name: 'dashboard'});
  }

  return next();
}
